module.exports = __webpack_public_path__ + "img/광안리 고기집.e1462d6b.png";